import { createContext, useContext } from 'react';
export const CardContext = /*#__PURE__*/createContext({});
const isInitializedContext = context => {
  return Object.keys(context).length > 0;
};
export function useCardContext() {
  const context = useContext(CardContext);
  if (!isInitializedContext(context)) {
    throw new Error('useCardContext must be used within an CardContextProvider');
  }
  return context;
}